<template>
  <div>
    <panel class="pt-6">
      <div class="flex flex-wrap items-center -mx-2" v-if="![7,8].includes(office.network_id)">
        <span class="text-xs font-bold w-full py-2">logo</span>
        <div class="flex justify-center items-center w-full">
          <div class="form-check form-check-inline flex items-center w-1/2">
            <label class="form-check-label inline-block text-gray-800 pr-12" for="standardwithoutlogo">
              <standard-qr colour="#000000"></standard-qr>
            </label>
            <input id="standardwithoutlogo" class="visible" type="radio" name="logoOptions" v-model="appearance.logo_qrcode" :value="false">
            <label class="text-xs" for="standardwithoutlogo">Without Logo</label>
          </div>
          <div class="form-check form-check-inline flex items-center w-1/2">
            <label class="form-check-label inline-block text-gray-800 pr-12" for="standardwithoutlogo" >
              <standard-qr-logo colour="#000000"></standard-qr-logo>
            </label>
            <input id="standardwithlogo" class="visible" type="radio" name="logoOptions" v-model="appearance.logo_qrcode" :value="true">
            <label class="text-xs" for="standardwithlogo">With Logo</label>
          </div>
        </div>
      </div>
      <hr class="border-b my-4 w-full" v-if="![7,8].includes(office.network_id)">
      <div class="flex flex-wrap items-center -mx-2">
        <span class="text-xs font-bold w-full py-2">QR code colour scheme</span>
        <div class="flex justify-center items-center w-full">
          <div class="form-check form-check-inline flex items-center w-1/3">
            <label class="form-check-label inline-block text-gray-800 pr-8" for="style1">
              <standard-qr v-if="final_logo==='qrcode'" colour="#000000"></standard-qr>
              <standard-qr-logo v-if="final_logo==='qrcode-logo'" colour="#000000"></standard-qr-logo>
            </label>
            <input id="style1" class="visible" type="radio" name="typeOptions" v-model="appearance.type_qrcode" value="black">
            <label class="text-xs" for="style1">Black (Standard)</label>
          </div>
          <div class="form-check form-check-inline flex items-center w-1/3">
            <label class="form-check-label inline-block text-gray-800 pr-8" for="style2">
              <standard-qr v-if="final_logo==='qrcode'" :colour="colour1"></standard-qr>
              <standard-qr-logo v-if="final_logo==='qrcode-logo'" :colour="colour1"></standard-qr-logo>
            </label>
            <input id="style2" class="visible" type="radio" name="typeOptions" v-model="appearance.type_qrcode" value="primary">
            <label class="text-xs" for="style2">Primary Colour</label>
          </div>
          <div class="form-check form-check-inline flex items-center w-1/3">
            <label class="form-check-label inline-block text-gray-800 pr-8" for="style3">
              <standard-qr v-if="final_logo==='qrcode'" :colour="colour2"></standard-qr>
              <standard-qr-logo v-if="final_logo==='qrcode-logo'" :colour="colour2"></standard-qr-logo>
            </label>
            <input id="style3" class="visible" type="radio" name="typeOptions" v-model="appearance.type_qrcode" value="secondary">
            <label class="text-xs" for="style3">Secondary Colour</label>
          </div>
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { v2Api } from '@/http'
import { debounce } from 'lodash'
import StandardQr from './qrcode-colour-icons/StandardQr.vue'
import StandardQrLogo from './qrcode-colour-icons/StandardQrLogo.vue'

export default {
  name: 'Appearance',
  components: {
    StandardQr,
    StandardQrLogo
  },
  data () {
    return {
      appearance: {
        type_qrcode: 'black',
        logo_qrcode: false
      },
      colour1: '',
      colour2: ''
    }
  },
  computed: {
    ...mapState({
      office: state => state.selectedOffice
    }),
    final_logo () {
      if (this.appearance.logo_qrcode) {
        return 'qrcode-logo'
      } else {
        return 'qrcode'
      }
    },
    rgb1: function () {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.colour1)
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : {
        r: 255,
        g: 255,
        b: 255
      }
    },
    rgb2: function () {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.colour2)
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : {
        r: 255,
        g: 255,
        b: 255
      }
    }
  },
  methods: {
    getAppearance: function () {
      v2Api.get(`/qr-code-appearance/${this.office.id}`).then(response => {
        this.appearance.type_qrcode = response.data.type_qrcode
        this.appearance.logo_qrcode = response.data.logo_qrcode
        this.colour1 = response.data.colour1
        this.colour2 = response.data.colour2
      }).catch(() => {
        alert('Unable to update Qr code appearance')
      })
    },
    updateAppearance: debounce(function () {
      v2Api.post(`/qr-code-appearance/${this.office.id}`, {
        type_qrcode: this.appearance.type_qrcode,
        logo_qrcode: this.appearance.logo_qrcode
      }).catch(() => {
        alert('Unable to update Qr code appearance')
      })
    }, 1000)
  },
  watch: {
    appearance: {
      handler () {
        this.updateAppearance()
      },
      deep: true
    }
  },
  created: function () {
    this.getAppearance()
  }
}
</script>
<style scoped>
input[type="radio"] {
  display: inline-block;
}

input[type="radio"] + label {
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  line-height: 1rem;
}

input[type="radio"]:checked + label::before {
  content: "";
  border-width: 0px;
}

input[type="radio"]:checked + label::before {
  background: white;
}
input[type="radio"] + label::before {
  content: '';
  display: inline-block;
  width: 0px;
  height: 0px;
  margin-right: 5px;
  border: 0px;
  padding: 0px;
  background: white;
}
</style>
